import { defineMessages } from 'react-intl';

export default defineMessages({
    choseProducerCodePlaceholder: {
        id: 'gateway.views.new-quote.Choose Producer Code',
        defaultMessage: 'Please Select',
    },
    choseProductPlaceholder: {
        id: 'gateway.views.new-quote.Choose Product',
        defaultMessage: 'Please Select',
    },
    producerCode: {
        id: 'gateway.views.new-quote.Producer Code',
        defaultMessage: 'Producer Code',
    },
    policyDetailsContainer: {
        "id": "gateway.views.new-quote.New Quote: Policy Details for Existing Client",
        "defaultMessage": "New Quote: Policy Details for Existing Client"
    },
    submissionProductCode :{
        "id": "gateway.views.new-quote.Line of Business",
        "defaultMessage": "Line of Business"
    },
    productCode :{
        "id": "gateway.views.new-quote.LineOfBusiness",
        "defaultMessage": "--Line of Business--"
    }
});
